export const SET_GROUP = 'SET_GROUP'
export const SET_GROUPS = 'SET_GROUPS'
export const RESET_GROUP = 'RESET_GROUP'
export const PROPERTY_GROUP_NAME_CHANGE = 'PROPERTY_GROUP_NAME_CHANGE'
export const PROPERTY_GROUP_COURSES_CHANGE = 'PROPERTY_GROUP_COURSES_CHANGE'
export const GROUP_COURSE_POSITION_CHANGE = 'GROUP_COURSE_POSITION_CHANGE'
export const PROPERTY_GROUP_MODULES_CHANGE = 'PROPERTY_GROUP_MODULES_CHANGE'
export const SET_ROLES = 'SET_ROLES'
export const SELECT_ROLE = 'SELECT_ROLE'
export const SET_GROUP_USERS = 'SET_GROUP_USERS'
export const SET_GROUP_COURSES = 'SET_GROUP_COURSES'
export const SET_GROUP_COURSES_WITH_POSITION = 'SET_GROUP_COURSES_WITH_POSITION'
export const SET_GROUP_ROLES = 'SET_GROUP_ROLES'
export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_GROUP_LOCATIONS = 'SET_GROUP_LOCATIONS'
export const SET_GROUP_STORES = 'SET_GROUP_STORES'
export const SET_GROUP_ASSOCIATES = 'SET_GROUP_ASSOCIATES'
export const TOGGLE_LEARNING_PLAN = 'TOGGLE_LEARNING_PLAN'
export const SET_GROUPS_COURSES = 'SET_GROUPS_COURSES'
export const SET_GROUP_INDEX = 'SET_GROUP_INDEX'
export const PRESENT = 'GROUP_PRESENT'
export const UNDO = 'GROUP_UNDO'
export const TOGGLE_GROUP = 'TOGGLE_GROUP'
export const UPLOAD_GROUP_STATUS = 'UPLOAD_GROUP_STATUS'
export const UPLOAD_GROUP_PERCENT = 'UPLOAD_GROUP_PERCENT'
export const SELECT_GROUP_FILE = 'SELECT_GROUP_FILE'
export const SET_GROUPS_LEARNING_PLAN = 'SET_GROUPS_LEARNING_PLAN'
export const SET_COURSE_INDEX = 'SET_COURSE_INDEX'
export const GROUPS_COURSES_LOADED = 'GROUPS_COURSES_LOADED'
export const SET_INDIVIDUAL_COURSES = 'SET_INDIVIDUAL_COURSES'
export const SET_ALL_COURSES = 'SET_ALL_COURSES'
export const GROUP_CLONE_STATUS = 'GROUP_CLONE'
export const GROUP_CLONED = 'GROUP_CLONED'
export const ASSING_GROUP_LOCATION = 'GROUP_ASSING_GROUP_LOCATION'
export const FILTER_GROUP_COURSES = 'GROUP_FILTER_GROUP_COURSES'
export const FILTER_GROUP_LOCATIONS = 'GROUP_FILTER_GROUP_LOCATIONS'
export const FILTER_GROUP_USERS = 'GROUP_FILTER_GROUP_USERS'
export const FILTER_GROUP_ROLES = 'GROUP_FILTER_GROUP_ROLES'
export const FILTER_GROUP_ASSOCIATES = 'FILTER_GROUP_ASSOCIATES'
export const SET_GROUP_DATES = 'GROUP_SET_GROUP_DATES'
export const TOGGLE_DATES = 'GROUP_TOGGLE_DATES'
export const SET_TAGS = 'SET_TAGS'
export const SET_TAG_DETAILS = 'SET_TAG_DETAILS'
export const SET_GROUP_OWNER = 'SET_GROUP_OWNER'
export const SET_GROUP_STATUS = 'SET_GROUP_STATUS'
export const SET_GROUP_SEARCH_VALUE = 'SET_GROUP_SEARCH_VALUE'
export const SET_SHOW_SELECTED_ITEMS = 'SET_SHOW_SELECTED_ITEMS'
export const SET_SHOW_SELECTED_LOCATION_ITEMS =
  'SET_SHOW_SELECTED_LOCATION_ITEMS'
export const SET_SHOW_SELECTED_LOCATION = 'SET_SHOW_SELECTED_LOCATION'
export const SET_SHOW_SELECTED_ROLES = 'SET_SHOW_SELECTED_ROLES'
export const SET_SHOW_SELECTED_STORES = 'SET_SHOW_SELECTED_STORES'
export const SET_SEARCH_BY_GROUPS = 'SET_SEARCH_BY_GROUPS'
export const SET_SEARCH_BY_COURSES = 'SET_SEARCH_BY_COURSES'
export const SET_GROUPS_COURSES_DATA = 'SET_GROUPS_COURSES_DATA'
export const SET_GROUPS_WITH_COURSES = 'SET_GROUPS_WITH_COURSES'
export const SET_ASSIGN_EXPANDED = 'SET_ASSIGN_EXPANDED'
export const SET_MANAGE_EXPANDED = 'SET_MANAGE_EXPANDED'
export const SET_USER_TRAINING = 'SET_USER_TRAINING'
export const SET_SELECTED_MANAGEABLE_TRAINING_USERS =
  'SET_SELECTED_MANAGEABLE_TRAINING_USERS'
export const SET_SELECTED_ASSIGNABLE_TRAINING_USERS =
  'SET_SELECTED_ASSIGNABLE_TRAINING_USERS'
export const SET_SELECTED_MANAGEABLE_TRAINING_LOCATIONS =
  'SET_SELECTED_MANAGEABLE_TRAINING_LOCATIONS'
export const SET_SELECTED_ASSIGNABLE_TRAINING_LOCATIONS =
  'SET_SELECTED_ASSIGNABLE_TRAINING_LOCATIONS'
export const SET_SELECTED_MANAGEABLE_TRAINING_STORES =
  'SET_SELECTED_MANAGEABLE_TRAINING_STORES'
export const SET_SELECTED_ASSIGNABLE_TRAINING_STORES =
  'SET_SELECTED_ASSIGNABLE_TRAINING_STORES'
export const SET_SELECTED_MANAGEABLE_TRAINING_ROLES =
  'SET_SELECTED_MANAGEABLE_TRAINING_ROLES'
export const SET_SELECTED_ASSIGNABLE_TRAINING_ROLES =
  'SET_SELECTED_ASSIGNABLE_TRAINING_ROLES'
export const SET_SELECTED_MANAGEABLE_TRAINING_LOCATION_GROUPS =
  'SET_SELECTED_MANAGEABLE_TRAINING_LOCATION_GROUPS'
export const SET_SELECTED_ASSIGNABLE_TRAINING_LOCATION_GROUPS =
  'SET_SELECTED_ASSIGNABLE_TRAINING_LOCATION_GROUPS'
export const SET_TRAINING_COURSES = 'SET_TRAINING_COURSES'
export const SET_TRAININGS = 'SET_TRAININGS'
export const SET_TRAININGS_WITH_COURSES = 'SET_TRAININGS_WITH_COURSES'
export const SET_MANAGEABLE_TRAININGS = 'SET_MANAGEABLE_TRAININGS'
export const SET_GROUP_LOCATION_GROUPS = 'SET_GROUP_LOCATION_GROUPS'
export const RESET_SELECTED_ITEMS = 'RESET_SELECTED_ITEMS'
export const SET_OWNED_GROUPS = 'SET_OWNED_GROUPS'
export const SET_LOADING = 'SET_LOADING'
export const SET_LOCATIONS_LOADING = 'SET_LOCATIONS_LOADING'
export const SET_TRAINING_DURATION = 'SET_TRAINING_DURATION'
export const RESET_TRAINING_DATES = 'RESET_TRAINING_DATES'
export const SET_EXPIRATION_TO_DATE = 'SET_EXPIRATION_TO_DATE'
export const SET_EXPIRATION_TO_DURATION = 'SET_EXPIRATION_TO_DURATION'
export const SET_EXPIRATION_TO_DISABLED = 'SET_EXPIRATION_TO_DISABLED'
export const TOGGLE_DO_NOT_ASSIGN = 'TOGGLE_DO_NOT_ASSIGN'
export const TOGGLE_AUTOMATIC_ENROLLMENT = 'TOGGLE_AUTOMATIC_ENROLLMENT'
export const TOGGLE_PIN_TO_NAVBAR = 'TOGGLE_PIN_TO_NAVBAR'
export const TOGGLE_PIN_TO_NAVBAR_DEVELOPMENT =
  'TOGGLE_PIN_TO_NAVBAR_DEVELOPMENT'
export const RESET_GROUP_DETAILS_DATA = 'RESET_GROUP_DETAILS_DATA'
export const SET_USER_GROUPS_COURSES = 'SET_USER_GROUPS_COURSES'
export const SET_EXPIRE_DATE = 'SET_EXPIRE_DATE'
export const SET_EXPIRE_PERIOD = 'SET_EXPIRE_PERIOD'
export const SET_REASSIGN_DATE = 'SET_REASSIGN_DATE'
export const SET_EXPIRE_PRIOR = 'SET_EXPIRE_PRIOR'
export const TOGGLE_EXPIRE_DATE = 'TOGGLE_EXPIRE_DATE'
export const SET_ORG_GROUPS = 'SET_ORG_GROUPS'
export const SET_ALL_GROUPS = 'SET_ALL_GROUPS'
export const SET_GROUP_INACTIVE = 'SET_GROUP_INACTIVE'
export const SET_EQUIVALENT_GROUP = 'SET_EQUIVALENT_GROUP'
export const SET_SINGLE_GROUP_INACTIVE = 'SET_SINGLE_GROUP_INACTIVE'
export const SET_GROUPS_COURSES_DATA_ALL = 'SET_GROUPS_COURSES_DATA_ALL'
export const SET_GROUPS_COURSES_ALL = 'SET_GROUPS_COURSES_ALL'
export const SET_GROUPS_WITH_COURSES_ALL = 'SET_GROUPS_WITH_COURSES_ALL'
export const SET_USER_GROUPS_COURSES_ALL = 'SET_USER_GROUPS_COURSES_ALL'
export const SET_LOCATION_GROUPS = 'SET_LOCATION_GROUPS'
export const UPDATE_DESCRIPTION = 'CHECKLIST_UPDATE_DESCRIPTION'
export const ADD_SECTION = 'GROUPS_ADD_SECTION'
export const SECTION_ACTIVE_INDEX = 'GROUPS_SECTION_ACTIVE_INDEX'
export const SET_SEARCH_GROUP_ON_CLICK = 'SET_SEARCH_GROUP_ON_CLICK'
export const CANCEL_SECTION = 'CANCEL_SECTION'
export const PREV_CHECKLIST_DESCRIPTION = 'PREV_CHECKLIST_DESCRIPTION'
export const SET_CORE_GROUP_COURSES = 'SET_CORE_GROUP_COURSES'
export const ENABLE_REORDER = 'ENABLE_REORDER'
export const ENABLE_HIERARCHY = 'ENABLE_HIERARCHY'
export const TOGGLE_ENABLE_REORDER = 'TOGGLE_ENABLE_REORDER'
//recently added
export const TOGGLE_ENABLE_GROUP_REORDER = 'TOGGLE_ENABLE_GROUP_REORDER'
export const SET_ROLE_GROUPS = 'SET_ROLE_GROUPS'
export const SELECT_ROLE_GROUPS = 'SELECT_ROLE_GROUPS'
export const SET_SHOW_SELECTED_ROLE_GROUPS = 'SET_SHOW_SELECTED_ROLE_GROUPS'
export const FILTER_ROLE_GROUPS = 'FILTER_ROLE_GROUPS'
export const SET_SELECTED_ASSIGNABLE_TRAINING_ROLE_GROUPS =
  'SET_SELECTED_ASSIGNABLE_TRAINING_ROLE_GROUPS'
export const SET_SELECTED_MANAGEABLE_TRAINING_ROLE_GROUPS =
  'SET_SELECTED_MANAGEABLE_TRAINING_ROLE_GROUPS'
export const SET_ROLE_GROUP_GROUPS = 'SET_ROLE_GROUP_GROUPS'
export const CHECKLIST = 'CHECKLIST'
export const SET_SELECTED_ROLES = 'SET_SELECTED_ROLES'
export const SET_USER_ROLES = 'SET_USER_ROLES'
export const SET_USERS_NOT_ASSIGNED_FROM_ROLE =
  'SET_USERS_NOT_ASSIGNED_FROM_ROLE'

export const TOGGLE_COMPLIANCE_GROUP = 'TOGGLE_COMPLIANCE_GROUP'
export const SET_COMPLIANCE_GROUP_INDEX = 'SET_COMPLIANCE_GROUP_INDEX'
export const SET_COMPLIANCE_GROUPS = 'SET_COMPLIANCE_GROUPS'
export const SET_INITIAL_COMPLIANCE_GROUPS = 'SET_INITIAL_COMPLIANCE_GROUPS'
